import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { FooterContactUsSingleElementFormState } from './FooterContactUsSingleElementForm.state';
import { FooterContactUsElementsState, ContactOptionType } from 'src/main/cms/FooterManagement/FooterManagement';
import {
    FormWrapper,
    ButtonWrapper,
    ActionButtonsWrapper,
    FooterContactUsElementCreateForm,
} from 'src/main/cms/FooterManagement/FooterContactUs/FooterContactUsElementsForm.style';
import { contactTypeSet } from './FooterContactUsType';
import { Input } from 'src/domains/layouts/shared/formComponents/input/Input';
import { useAppStateContext } from 'src/AppState/AppState';

interface FooterContactUsSingleElementFormPropsType {
    contactUsState: FooterContactUsElementsState;
    contactType: ContactOptionType;
}

export const FooterContactUsSingleElementForm = observer(
    'FooterContactUsSingleElementForm',
    ({ contactUsState, contactType }: FooterContactUsSingleElementFormPropsType) => {
        const { trpcClient } = useAppStateContext();

        const [state] = useState(
            () => new FooterContactUsSingleElementFormState(contactUsState, contactType, trpcClient)
        );
        const { handleCreate, contactValue, contactLabel } = state;

        return (
            <FormWrapper
                extraMarginBottom={true}
                data-test={`footer-contact-us-new-element-${contactType}`}
            >
                <FooterContactUsElementCreateForm
                    onSubmit={(e: React.FormEvent<HTMLFormElement>): void => {
                        e.preventDefault();
                    }}
                >
                    {contactTypeSet(contactType)?.icon}
                    <Input
                        label='Label'
                        formInputState={contactLabel}
                        dataTest='footer-contact-us-input-label'
                    />
                    <Input
                        label={contactTypeSet(contactType)?.label}
                        formInputState={contactValue}
                        dataTest='footer-contact-us-input'
                    />
                </FooterContactUsElementCreateForm>
                <ActionButtonsWrapper>
                    <ButtonWrapper
                        onClick={(): Promise<void> => handleCreate()}
                        dataTest='footer-contact-us-add-button'
                    >
                        Add
                    </ButtonWrapper>
                </ActionButtonsWrapper>
            </FormWrapper>
        );
    }
);
